import { Injectable } from '@angular/core';
import { ApiService, ErrorMapType } from './api.service';
import { CurrencyId, decimal, ExchangeRate } from '@gains-com/shared';

@Injectable({
  providedIn: 'root',
})
export class ExchangeRatesService extends ApiService {
  private static _rateCache = new Map<string, ExchangeRate>();
  private _cacheExpiry = 10000; // 10 seconds

  readonly ErrorMap: ErrorMapType = {};

  async getExchangeRateForCurrencyPair(
    baseCurrencyId: CurrencyId,
    targetCurrencyId: CurrencyId
  ) {
    return await this.get<ExchangeRate>(
      `/exchange-rates/${baseCurrencyId}/${targetCurrencyId}`
    );
  }

  async convertCurrency(
    amount: number | string,
    baseCurrencyId: CurrencyId,
    targetCurrencyId: CurrencyId
  ) {
    if (Number.isNaN(Number(amount))) {
      return 0;
    }

    let rate = ExchangeRatesService._rateCache.get(
      `${baseCurrencyId}:${targetCurrencyId}`
    );

    if (
      !rate ||
      new Date(rate.timestamp).getTime() <
        new Date().getTime() - this._cacheExpiry
    ) {
      rate = await this.getExchangeRateForCurrencyPair(
        baseCurrencyId,
        targetCurrencyId
      );

      ExchangeRatesService._rateCache.set(
        `${baseCurrencyId}:${targetCurrencyId}`,
        rate
      );

      ExchangeRatesService._rateCache.set(
        `${targetCurrencyId}:${baseCurrencyId}`,
        {
          exchange_rate_id: rate.exchange_rate_id,
          base_currency_id: targetCurrencyId,
          target_currency_id: baseCurrencyId,
          rate: decimal(1).div(rate.rate).toNumber(),
          timestamp: rate.timestamp,
        }
      );
    }

    return decimal(amount ?? 0)
      .mul(rate.rate ?? 0)
      .toNumber();
  }
}
